import { Toast } from "react-bootstrap";

const FailedRequest = ({ message, showAlert, setShowAlert }) => {
  const zIndex = 2147483647;
  return (
    <Toast
      bg='danger'
      onClose={setShowAlert}
      autohide
      show={showAlert}
      delay={5000}
      style={{ zIndex, position: 'fixed', top: 20, right: '40%' }}>
      <Toast.Body><p className="text-white p-0 m-0">{message}</p></Toast.Body>
    </Toast>
  );
};

export default FailedRequest;